'use client';

import React, { createContext, Dispatch, FC, ReactNode, SetStateAction, useMemo, useState } from 'react';
import { useMedia } from 'react-use';

import { ProfileCreationContent } from '../_components/ProfileCreationContent';

import { Dialog, DialogContent, DialogPortal } from 'components/ui/dialog';
import { Sheet, SheetContent, SheetPortal } from 'components/ui/sheet';

import { CommunityInfoNode, CurrentUserType } from 'types';

interface ILinkedinContextProvider {
  communityInfo?: CommunityInfoNode | null;
  user?: CurrentUserType | null;
  children: ReactNode;
}

interface ILinkedinContext {
  setLinkedinModalState: Dispatch<SetStateAction<LinkedinModalState>>;
}

type LinkedinModalState = 'WELCOME' | 'ADD_LINK' | null;

const defaultValues: ILinkedinContext = {
  setLinkedinModalState: () => void 0,
};

const LinkedinContext = createContext(defaultValues);

export const LinkedinContextProvider: FC<ILinkedinContextProvider> = (props) => {
  const { children, user } = props;
  const [addLinkedinModalState, setLinkedinModalState] = useState<LinkedinModalState>(null);

  const isMobile = useMedia('(max-width: 768px)', false);
  const value: ILinkedinContext = useMemo(() => ({
    setLinkedinModalState,
  }), []);

  const DialogRoot = isMobile ? Dialog : Sheet;
  const Portal = isMobile ? DialogPortal : SheetPortal;
  const Content = isMobile ? DialogContent : SheetContent;

  return (
    <LinkedinContext.Provider value={value}>
      {children}
      {!user?.profileStatus && !!addLinkedinModalState && (
        <DialogRoot open onOpenChange={() => setLinkedinModalState(() => null)}>
          <Portal>
            <Content
              showClose
              className="bg-white border-0 outline-none text-black p-[70px] max-w-[700px] items-center flex rounded-l-4xl md:!rounded-none md:!px-6 md:!py-8 md:!max-w-full md:!w-full md:h-full"
            >
              <ProfileCreationContent
                user={user}
                onSuccess={() => setLinkedinModalState(() => null)}
              />
            </Content>
          </Portal>
        </DialogRoot>
      )}
    </LinkedinContext.Provider>
  );
};

export default LinkedinContext;
